// extracted by mini-css-extract-plugin
export default {"root":"Product_root__4luXz","image":"Product_image__d1g4P"};